import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Drawer as MuiDrawer } from '@material-ui/core';
import cn from 'classnames';
import { merge } from 'lodash-es';
import { CloseButton } from '../CloseButton';
import styles from './Drawer.module.scss';
import { useDrawerStyles } from './Drawer.styles';
export function Drawer(props) {
    const { children, className, header, footer, onCloseButtonClick, disableCloseButton = false, hasTopbar, headerClassName, showDividers = true, minWidth = 444, anchor = 'right', testId } = props, rest = _object_without_properties(props, [
        "children",
        "className",
        "header",
        "footer",
        "onCloseButtonClick",
        "disableCloseButton",
        "hasTopbar",
        "headerClassName",
        "showDividers",
        "minWidth",
        "anchor",
        "testId"
    ]);
    const classes = useDrawerStyles();
    return /*#__PURE__*/ _jsx(MuiDrawer, _object_spread_props(_object_spread({}, rest), {
        anchor: anchor,
        className: cn({
            [classes.root]: hasTopbar
        }, className),
        "data-testid": testId,
        ModalProps: merge({
            BackdropProps: {
                classes: {
                    root: classes.backdrop
                }
            }
        }, rest.ModalProps),
        PaperProps: merge({
            classes: {
                root: classes.paper
            }
        }, rest.PaperProps),
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.root,
            style: {
                minWidth
            },
            children: [
                header && /*#__PURE__*/ _jsxs("div", {
                    className: cn(styles.header, headerClassName, {
                        [styles.noDividers]: !showDividers
                    }),
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.headerContent,
                            children: header
                        }),
                        onCloseButtonClick && /*#__PURE__*/ _jsx(CloseButton, {
                            testId: testId && "".concat(testId, "-close-button"),
                            size: "small",
                            onClick: onCloseButtonClick,
                            disabled: disableCloseButton
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.content,
                    children: children
                }),
                footer && /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.footer, {
                        [styles.noDividers]: !showDividers
                    }),
                    children: footer
                })
            ]
        })
    }));
}
